import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType, _ProductionRoute } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SelectProductionRoute = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista, bean, setBean, handleChange } = useDataBean(_ProductionRoute);
    const [id, setID] = useState(null);
    const [valRender, setValRender] = useState<string>(render)

    const modal = useModal("Rutas de Producción", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDProductionRoute == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);

            } else {
                onChange(returnType === "Object" ? {} : null);
            }

            setValRender(selectedItem.DataBeanProperties.Name)
        }
    };


    const getLista = () => {

        instance.getProductionRouteCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDProductionRoute', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Rutas de Producción"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{valRender ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDProductionRoute); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}